export default "__VITE_ASSET__DJWC83U0__"